const root = state => state.portalScopes;
export const getPortalScopes = state => root(state).portalScopes;
export const getPortalScopesRequestState = state => root(state).portalScopesRequestState;